angular.module('iqxCore')
.service('JobSearchSvc', function (ApiSvc, $q, ApplicationSvc) {
  var svc=this
  
  svc.searchValues={}
  
  svc.setupGeoLocation=function(){
    svc.GeoLocation={}
    function savePos(p) {
      svc.GeoLocation.currentLocation={type:"Point",coordinates:[p.coords.longitude,p.coords.latitude]}
      svc.GeoLocation.allowed=true
    }      
    if (navigator.geolocation) {  // Browser supports it
      navigator.geolocation.getCurrentPosition(savePos);
    } 
  }
    
  svc.setupGeoLocation()  // Do it on service load
    
	svc.serialize=function(obj) {
	  var str = [];
	  for(var p in obj)
	    if (obj.hasOwnProperty(p)) {
	      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
	    }
	  return str.join("&");
	}
  
  svc.isSwitchedOn=function (xSwitch) {
    return (ApplicationSvc.currentUser.Switches && ApplicationSvc.currentUser.Switches.indexOf(xSwitch)>=0)
    }
  
	svc.getSearchFields=function(){
    if (svc.searchFields && (svc.sfCheck===ApplicationSvc.currentUser.UserName)){
      return $q.when() // already fetched - return fulfilled promise
    }
    var prom=$q.when() // Will be over-ridden if filtering departments
    var depts=[]
    var jtypes=[]
    if (ApplicationSvc.isLoggedIn && svc.isSwitchedOn('FILTERJOBSEARCHALLOW')){
      prom=ApiSvc.fetch(svc,{fetchAPI:'callresult/NetCandidateRegistrations', multiRow:true, fetchTarget:'deptReg', booleanFields:['TempJobs','PermJobs']})
      .then(function(){    // Narrow down department and jobtype depending on registration choices
         var t, p
         angular.forEach(svc.deptReg, function(d){
           if (d.TempJobs || d.PermJobs){
             depts.push(d.DepartmentName)
             t=t || d.TempJobs
             p=p || d.PermJobs
           }
         })
         if (t) {
           jtypes.push('Contract')
           jtypes.push('Shift')
           }
         if (p) {
           jtypes.push('Permanent')
         }
      })
    }
    return prom.then(function(){return ApiSvc.fetch(svc,{fetchAPI:'jobs/fields', multiRow:true, notLoggedIn:true, fetchTarget:"rawFields"})})
		.then(function(){
      svc.searchFields=[]
      svc.rawFieldNames=['$text']  // Used for removing no longer existing fields from search
      svc.dateFields=[]
      svc.ucaseFields=[]
			angular.forEach(svc.rawFields,function(p){
        svc.rawFieldNames.push(p.name)
				var q={
					id:p.name,
					label:p.caption,
					search:p.search
				}

				if (p.name=="jobtype") {
          if(jtypes.length){
            p.choices=jtypes
          } else {
            p.choices.unshift("All")
          }
				} else if (p.name=="department") {
          if(depts.length){
            p.choices=depts
          } else {
            p.choices.unshift("All")
          }
				} else if (p.name=="GeoLocation") {
          svc.GeoLocation.data=true  // Mongo db contains GeoLocation data
        }

				if(p.type=='select' || p.type=='multiselect'){
					if(p.type=='multiselect'){
						q.type='X'
					} else {
						q.type='K'
					}
					q.options=[{Value:'', Description:''}]
					angular.forEach(p.choices, function(o){
						q.options.push({Value:o,Description:o})
					})
				} else if (p.type=='numeric'){
					q.type='N'
				} else if (p.type=='string'){
					q.type='T'
				} else if (p.type=='uppercase'){
					q.type='U'
          svc.ucaseFields.push(p.name)
				} else if (p.type=='date'){
					q.type='D'
          svc.dateFields.push(p.name)
				}
				if(p.required){
					q.required="required"
				} else{
					q.required=false
				}
				if (q.type){
					svc.searchFields.push(q)
				}
			})

			var q={
				id:"$text",
				label:"Search",
				search:true,
				type:"T",
				required:false,
				placeholder:"Keyword Search"
			}
			svc.searchFields.push(q)
      svc.sfCheck=ApplicationSvc.currentUser.UserName
		})
	}
  
  svc.searchInit=function(){
    svc.rawJobs=undefined
    svc.currentPage=1
  }
  
  svc.findJobs=function(){
    if (svc.rawJobs && (svc.rjCheck===ApplicationSvc.currentUser.UserName)){
      return $q.when() // already fetched - return fulfilled promise
    }
    for (var propName in svc.searchValues) { 
      if ((!svc.searchValues[propName]) || (svc.rawFieldNames.indexOf(propName)<0)) {
        delete svc.searchValues[propName] // Remove if empty or no longer in list of fields
      }
    }
    var mongoValues=angular.copy(svc.searchValues)
    for (var propName in mongoValues) {
      if (mongoValues[propName]=='All') {
        delete mongoValues[propName]
      } else if (svc.ucaseFields.indexOf(propName)>=0) {
        mongoValues[propName]=mongoValues[propName].toUpperCase()
      } else if (svc.dateFields.indexOf(propName)>=0) {
        mongoValues[propName]={$lte: moment().add(mongoValues[propName],'days').format('YYYY-MM-DD')}
      } else if (propName=='GeoLocation') {
        var d=parseFloat(mongoValues[propName])
        if (d && (d>0) && svc.GeoLocation.allowed && svc.GeoLocation.data){
          mongoValues[propName]={maxDistance:d,from:svc.GeoLocation.currentLocation}
        } else {
          delete mongoValues[propName]
        }
      }
    }
    return ApiSvc.exec(svc,'jobs/jobs',mongoValues, true)
    .then(function(data){
      svc.rawJobs=data.IQXResult.Row
      svc.rjCheck=ApplicationSvc.currentUser.UserName
    })
    .then(function(){
      svc.processGeoLocations()
    })
  }
  
  svc.findJob=function(vacancyid){
    svc.rawJob=undefined
    if (svc.rawJobs && (svc.rjCheck===ApplicationSvc.currentUser.UserName)){
      angular.forEach(svc.rawJobs, function(job){ 
        if (job.vacancyid == vacancyid){
          svc.rawJob=job
        }
      })
    }
    if (svc.rawJob){
      return $q.when() // job found in fetched array, no need to trouble server
    }
    return ApiSvc.exec(svc,'jobs/jobs',{vacancyid:vacancyid}, true)
    .then(function(data){
      var r=data.IQXResult.Row
      if (r.count==0) {
        return  // with svc.rawJob undefined
      }
      svc.rawJob=r[0]
    })
  }
  
  svc.GeoDistance=function(p1,p2){
    var R = 3963.2 // miles at equator. 6,378.1 km
    var lon1=p1.coordinates[0]
    var lat1=p1.coordinates[1]
    var lon2=p2.coordinates[0]
    var lat2=p2.coordinates[1]
    var dLat = (lat2-lat1).toRad()
    var dLon = (lon2-lon1).toRad() 
    var a = Math.sin(dLat/2) * Math.sin(dLat/2) + 
        Math.cos(lat1.toRad()) * Math.cos(lat2.toRad()) *
        Math.sin(dLon/2) * Math.sin(dLon/2)
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)) 
    return R * c
  }

  svc.processGeoLocations=function(){
    if (svc.GeoLocation.allowed && svc.GeoLocation.data){
      angular.forEach(svc.rawJobs,function(j){
        if (j.GeoLocation){
          j.GeoDistance=svc.GeoDistance(svc.GeoLocation.currentLocation,j.GeoLocation)
        }
      })
    }
  }

})
